import ModuleHomeUrl from 'dashboard/leftSideDrawer/ModuleHomeUrl';
import OhsDocumentFilterModels from 'documents/register/search/OhsDocumentFilterModels';

import { OhsUser } from '../../user/OhsUser';
import OhsBreadcrumbsNameAndRef from './OhsBreadcrumbsNameAndRef';

const OhsBreadCrumbDocuments = (
  ohsBreadcrumbsNameAndRef: OhsBreadcrumbsNameAndRef,
  modulePath: string,
  subPath: string,
  operationPath: string,
  user: OhsUser,
  searchParams: URLSearchParams
) => {
  const { folderView } = new OhsDocumentFilterModels({ searchParams });

  if (subPath === 'home') {
    if (folderView) {
      ohsBreadcrumbsNameAndRef.moduleRef = {
        name: user.configs.vdoc?.TITLE ?? '',
        href: (ModuleHomeUrl[user.tier.type] as any).vdoc,
      };
    } else {
      ohsBreadcrumbsNameAndRef.leafName = {
        name: user.configs.vdoc?.TITLE ?? '',
      };
    }
  } else if (operationPath.indexOf('/view') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = {
      href: (ModuleHomeUrl[user.tier.type] as any).vdoc,
      name: user.configs.vdoc?.TITLE ?? '',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'View' };
  } else if (operationPath.indexOf('completed') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = {
      href: (ModuleHomeUrl[user.tier.type] as any).vdoc,
      name: user.configs.vdoc?.TITLE ?? '',
    };
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/view`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Evidence' };
  } else if (operationPath.indexOf('signoff') > -1) {
    ohsBreadcrumbsNameAndRef.moduleRef = {
      href: (ModuleHomeUrl[user.tier.type] as any).vdoc,
      name: user.configs.vdoc?.TITLE ?? '',
    };
    ohsBreadcrumbsNameAndRef.parentOperationRef = {
      href: `/${modulePath}/${subPath}/view`,
      name: 'View',
    };
    ohsBreadcrumbsNameAndRef.leafName = { name: 'Signoff' };
  }
  return ohsBreadcrumbsNameAndRef;
};

export default OhsBreadCrumbDocuments;
